import { z } from "zod";

export const mainICafeResponseSchema = z.object({
  idx: z.number(),
  iCafeId: z.string(),
  playncAccountId: z.string(),
  pcCafeAccount: z.string(),
  isPrimary: z.boolean(),
  registeredAt: z.string(),
  updatedAt: z.string(),
  sort: z.number(),
  managerMobileMarketingPolicyAgree: z.boolean(),
  managerMobilePhoneNumber: z.string().optional(),
});

export type MainICafeResponseType = z.infer<typeof mainICafeResponseSchema>;
